import { createSlice } from "@reduxjs/toolkit";
import { getSpecialities, getSpecialitieswithSub } from "./specialitiesApi";
import { getSubSpecialities } from "./subSpecialitiesApi";

// Slice for managing master doctor state
const specialitiesSlice = createSlice({
  name: "specialities",
  initialState: {
    specialities: [],
    subSpecialities: [],
    getAllSpecialities: [],
    loading: false,
    error: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalSpecialties: 0,
  },
  extraReducers: (builder) => {
    // GET specialties FILTER WISE DATA
    builder.addCase(getSpecialities.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getSpecialities.fulfilled, (state, action) => {
      state.loading = false;
      state.specialities = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalSpecialties = action.payload.meta.total;
    });
    builder.addCase(getSpecialities.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getSpecialitieswithSub.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getSpecialitieswithSub.fulfilled, (state, action) => {
      state.loading = false;
      state.getAllSpecialities = action.payload.data;
    });
    builder.addCase(getSpecialitieswithSub.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getSubSpecialities.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSubSpecialities.fulfilled, (state, action) => {
      state.loading = false;
      state.subSpecialities = action.payload;
    });
    builder.addCase(getSubSpecialities.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default specialitiesSlice.reducer;
